;(function($, window, document, undefined) {

	var focasableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	var fscss = $.featherlight.defaults.namespace;
	$.featherlight.defaults.loading = '<div class="ft-loading">Loading&hellip;</div>';

	$.featherlight.prototype.beforeOpen = function(e) {
		var dataset = e.currentTarget.dataset;

		if ( dataset.video !== undefined ) {
			var video = dataset.video;
			var poster = dataset.poster;
			$('#modal .modal__ctn').html('<video id="player5aabe50b2cfac24900e963f1" width="716" height="402" poster="' + poster + '" controls=""><source src="' + video + '" type="video/mp4"></video>');
		}
		else if ( dataset.youtube !== undefined ) {
			$('#modal .modal__ctn').html('<div class="video"><div class="video__wrap"><iframe src="https://www.youtube.com/embed/'+ dataset.youtube +'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></div>');
		}
	}

	$.featherlight.prototype.afterContent = function() {

		// Subscribe form - updating IDs on the cloned form to make the cloned label/input relationships work.
		var form = $('.featherlight-wrap .subscribe-form');
		if ( form.length > 0 ) {
			form.find('.form-control').attr('id', form.find('.form-control').attr('id') + '--modal').attr('tabindex', '');
			form.find('.form-label').attr('for', form.find('.form-label').attr('for') + '--modal');
		}
		
		$('.featherlight-wrap .btn').attr('tabindex', '');

	}

	$.featherlightGallery.prototype.afterContent = function() {
		
		// Setting up images
		var card = this.$currentTarget.closest('.card--image');
		if ( card.length > 0 ) {
		  var caption = card.find('.card__title').text(),
		      download = card.find('.download').clone();
	  	this.$instance.find('.caption').remove();
	  	$('<div class="caption">').text(caption).appendTo(this.$instance.find('.featherlight-wrap'));
	  	$('.featherlight-wrap .caption').append(download);
		}

	};	

	var transitionsSupported = ('transition' in document.documentElement.style) || ('webkitTransition' in document.documentElement.style);

	// ---------------------------------------------------------------------------------------- [ BREAKPOINT HELPERS
	var media_queries = {
		mob:     'screen and (min-width: 20em)', 
		phab:    'screen and (min-width: 26.5625em)', 
		tab:     'screen and (min-width: 48em)',
		lap:     'screen and (min-width: 64em)',
		desk:    'screen and (min-width: 75em)',
	  common:  'screen and (min-width: 85.375em)',
		wide:    'screen and (min-width: 90em)',
	  lapdown: 'screen and (max-width: 63.9375em)',
	  tabdown: 'screen and (max-width: 47.9375em)',
	};

	window.testScreenSize = $(window).width();

	function checkBreakPoint(key) {

		mq = window.matchMedia(media_queries[key]);
		return mq.matches;

	}

	// ---------------------------------------------------------------------------------------- [ COOKIE HELPER
	window.getCookie = function(name) {
	  var value = "; " + document.cookie;
	  var parts = value.split("; " + name + "=");
	  if (parts.length == 2) return parts.pop().split(";").shift();
	}

	window.acceptCookies = function() {
		var date = new Date();
		date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
		document.cookie = "acceptCookies=true; expires=" + date.toGMTString() + "; path=/";
		$cookieMsg = document.getElementById('cookieMsg');
		$cookieMsg.classList.remove('js-show');
	}

	window.getQueryVariable = function(variable, query) {
		if ( ! query ) { return query; }
		var vars = query.split('&');
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split('=');
			if (decodeURIComponent(pair[0]) == variable) {
				return decodeURIComponent(pair[1]);
			}
		}
		console.log('Query variable %s not found', variable);
	}

	if (document.getElementById('cookieMsg')) {
		var globalPermissions = getCookie('permissions');
		var globalConsent = window.getQueryVariable('consented', globalPermissions);
		if ( getCookie('acceptCookies') !== 'true' && globalConsent !== 'true') {
			$cookieMsg = document.getElementById('cookieMsg');
			$cookieMsg.classList.add('js-show');
			var focusable = $cookieMsg.querySelector(focasableElements);
			console.log(focusable);
			if ( focusable ) {
				focusable.focus();
			}	
		}
	}	

	$('body').keypress(function(e) {
  	if (e.keyCode === 12) {
  		$(this).toggleClass('js-show-grid');
  	}
	});

	// ---------------------------------------------------------------------------------------- [ WINDOW RESIZE FUNCTIONS
	$(window).on('resize', function(){

		if ( window.testScreenSize !== $(window).width() ) {

			// if ( checkBreakPoint('lap') && ! social_is_stuck ) {
			// 	stick_social();
			// }

			// if ( checkBreakPoint('lapdown') && social_is_stuck ) {

			// 	$('.social-sharing').trigger("sticky_kit:detach");
			// 	social_is_stuck = false;
				
			// }

			window.testScreenSize = $(window).width();

		}

	});


	// ---------------------------------------------------------------------------------------- [ MENU - TOGGLE
	$('body').on('click', function(e) {

		var target = $(e.target);
		escapeMenu(target);

	});

	window.toggleBooleanAttr = function (index, attr) {
		return attr == 'true' ? 'false' : 'true';
	}

	// Navigation ---------------------------------------------------------------------------------------- //
	window.toggleNav = function(show, close) {
		if ( ! show ) {
			show = false;
		}
		if (!close) {
			close = false;
		}
		body = $('body');
		var button = $('.header-button.js-toggle-nav');
		var nav = $('.nav.nav--global');
		if ( show ) {
			body.toggleClass('js-show-nav');
			button.attr('aria-expanded', window.toggleBooleanAttr);
			nav.attr('aria-hidden', window.toggleBooleanAttr);
			if (body.hasClass('js-show-nav')) {
				setTimeout(function() {
					focusTrap['nav'][0].focus();
				}, 100);
			}
		} else {
			body.removeClass('js-show-nav');
			button.attr('aria-expanded', 'false');
			nav.attr('aria-hidden', 'true');
			if ( close ) {
				setTimeout(function() {
					button.focus();
				}, 100);
			}
		}
	};

	// Focus Trap
	var focusTrap = [];
	$(document).ready(function () {
		focusTrap['nav'] = $('.nav.nav--global').find(focasableElements);
		focusTrap['search'] = $('.search-form').find(focasableElements);
		focusTrap['cookie'] = $('#cookieMsg').find(focasableElements);
	});

	$('[data-foucs-trap]').on('keydown', function (e) {
		var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);
		var trap = $(this).attr('data-foucs-trap');

		if (!isTabPressed) {
			return;
		}

		var firstFocusableElement = focusTrap[trap][0];
		var lastFocusableElement  = focusTrap[trap][focusTrap[trap].length - 1];

		if (e.shiftKey) {
			// Shift + Tab
			if (document.activeElement === firstFocusableElement) {
				e.preventDefault();
				lastFocusableElement.focus();
			}
		} else {
			// Tab
			if (document.activeElement === lastFocusableElement) {
				e.preventDefault();
				firstFocusableElement.focus();
			}
		}
	});

	window.toggleSearch = function (show, close) {
		if (!show) {
			show = false;
		}
		if (!close) {
			close = false;
		}
		body = $('body');
		var button = $('.header-button.js-toggle-search');
		var search = $('.search-form');
		if (show) {
			if ( ! body.hasClass('js-show-search') ) {
				setTimeout(function () { $('#searchsection').focus(); }, 100);
			}
			body.toggleClass('js-show-search');
			button.attr('aria-expanded', window.toggleBooleanAttr);
			search.attr('aria-hidden', window.toggleBooleanAttr);
		} else {
			body.removeClass('js-show-search');
			button.attr('aria-expanded', 'false');
			search.attr('aria-hidden', 'true');
			if (close) {
				setTimeout(function () {
					button.focus();
				}, 100);
			}			
		}
	};
	
	window.toggleLanguage = function (show) {
		if (!show) {
			show = false;
		}
		var button = $('.js-toggle-language-selector');
		var selector = button.closest('.language-selector');	
		var list = $('.language-selector__list');
		if (show) {
			selector.toggleClass('js-active');
			button.attr('aria-expanded', window.toggleBooleanAttr);
			list.attr('aria-hidden', window.toggleBooleanAttr);
		} else {
			selector.removeClass('js-active');
			button.attr('aria-expanded', 'false');
			list.attr('aria-hidden', 'true');
		}
	};	

	$('.language-selector__list').on('focusout', function($event) {
		setTimeout(function () {
			if ($(document.activeElement).closest('.language-selector__list').length == 0) {
				toggleLanguage();
			}
		}, 10)
	});

	$('.close-element').on('click', function (e) {

		var target = $(e.currentTarget, true);
		body = $('body');
		
		// Close nav
		if (compareNavTarget(target.closest('.nav--global').length, true) &&
			target.hasClass('close-element')) {
			// body.removeClass('js-show-nav');
			window.toggleNav(false, true);
		}

		if (compareNavTarget(target.closest('.search-form').length, true) &&
			target.hasClass('close-element')) {
			window.toggleSearch(false, true);
		}

		$(this).blur();
		
	});

	$('body').on('keyup', function(e) {
		var code = e.keyCode;
		var KEY_ESC = 27;
		if ( code === KEY_ESC ) {
			body = $('body');
			window.toggleNav();
			window.toggleSearch();
			$('.media-selector').removeClass('js-active');
			$('.language-selector').removeClass('js-active');
		}
	});

	function compareNavTarget(length, inner) {
		return inner ? (length >= 1) : (length < 1);
	}

	function escapeMenu(target, inner) {

		if ( ! inner ) {
			inner = false;
		}

		body = $('body');

		// Close nav
		if (compareNavTarget(target.closest('.nav--global').length, inner) &&
			!target.hasClass('js-toggle-nav') &&
			!target.parent().hasClass('js-toggle-nav')) {
			window.toggleNav();
		}

		// Close search
		if (compareNavTarget(target.closest('.search-form').length, inner) &&
			!target.hasClass('js-toggle-search') &&
			!target.parent().hasClass('js-toggle-search')) {
			body.removeClass('js-show-search');
		}

		// Close search
		if (compareNavTarget(target.closest('.media-selector').length, inner) && !target.hasClass('js-toggle-media-selector')) {
			$('.media-selector').removeClass('js-active');
		}

		// Close search
		if (compareNavTarget(target.closest('.language-selector').length, inner) && !target.hasClass('js-toggle-language-selector')) {
			window.toggleLanguage();
		}		

	}

	// ---------------------------------------------------------------------------------------- [ MENU - TOGGLE
	$('.js-toggle-nav').on('click', function($e){

		$e.stopPropagation();
		toggleNav(true);
		
	});

	// ---------------------------------------------------------------------------------------- [ SEARCH - TOGGLE
	$('.js-toggle-search').on('click', function ($e){

		$e.stopPropagation();
		toggleSearch(true)
		
	});

	// ---------------------------------------------------------------------------------------- [ MENU - FOCUS
	$('.nav .menu > ul li a').on('focusin focusout', function() {
		$(this).parents("li").toggleClass("hover");
	});

	$('.nav--global .menu > ul > .menu__item').on('focusin', function(e) {

		var item = $(this);

  	$(window).unbind('keyup');
    $(window).keyup(function (e) {

        var code = (e.keyCode ? e.keyCode : e.which);
        if (code == 9 && checkBreakPoint('tabdown') ) {

					if ( item.hasClass('js-current-open') ) {

					} else if ( item.hasClass('js-focus	-out') ) {

						item.removeClass('js-focus	-out'); 

					} else {

						var open_item = $('.js-current-open').first();

						open_item.find(".sub-menu").slideUp();
						open_item.removeClass('js-current-open js-active');			

						item.find(".sub-menu").slideDown();
						item.addClass('js-active');
					}

        }

    });

	});

	$('.nav--global .menu > ul > .menu__item').on('focusout', function() {

		var item = $(this);
		
        if (checkBreakPoint('tabdown') ) {

					item.addClass('js-current-open');

				}

	});	

	$('.header').on('focusin', '*', function(e) {

		var item = $(this);
	
    if ( checkBreakPoint('tabdown') ) {

			if( $('body').hasClass('js-show-nav') ){

				e.stopPropagation();

				if ( $(this).closest('.menu__item').length < 1) {

					var open_item = $('.js-current-open').first();

					open_item.find(".sub-menu").slideUp();
					open_item.removeClass('js-current-open js-active');
					open_item.addClass('js-focus-out');

				}

			}

		}

	});


	// ---------------------------------------------------------------------------------------- [ FOOTER MENU
	$('.js-toggle-footer-menu').on('click', function(e){

		var col = $(this).closest('.footer__column');
		var menu = col.find('.menu-wrap');

		menu.slideToggle();
		$(this).toggleClass('js-active');

	});


	// ---------------------------------------------------------------------------------------- [ MODAL - TRIGGER / AJAX LOAD
	$('.js-modal-trigger').on('click', function(e) {

		e.preventDefault();

		var $trigger = $(this);
		var slug = $trigger.attr('data-modal-slug');
		var lang = ($('html').attr('lang') === 'fr-CA') ? '/fr/' : '';
		var ajaxUrl = window.location.protocol + '//' + window.location.hostname + lang + '/modal?m=' + slug;

		console.log(ajaxUrl);

		//special cookie case for plan modal
		if (slug == 'plan-select') {
			var date = new Date();
      date.setTime(date.getTime()+(365*24*60*60*1000));
      document.cookie = "plan=" + $trigger.attr('data-plan') + "; expires=" + date.toGMTString() + "; path=/";
      updateActivePlan();
		}

		$.ajax(ajaxUrl, {
			dataType: 'html',
			success: function(response) {

				triggerModal(response, slug, $trigger);

			},
			error: function( jqXHR, exception ) {
			  console.log( "AJAX request failed: " + exception );
			}

		});
	});

	window.triggerModal = function(htmlContent, modalSlug, $trigger) {

		//add the AJAX template
		$('.modal .modal__content').html(htmlContent);

		//for each slot in the modal, fill in the value from the trigger's data attr if present
		if ($trigger) {
			$('.modal__slot').each(function() {
				var slotNum = $(this).attr('data-modal-slot');
				if ($trigger.attr('data-modal-slot-' + slotNum)) {
					$(this).text($trigger.attr('data-modal-slot-' + slotNum));
				} else {
					$(this).text('N/A');
				}
			});
		};

		//show modal
		$('.modal').attr('data-slug', modalSlug).attr('aria-hidden', 'false');
		$('body').addClass('has-modal');

	}

	// ---------------------------------------------------------------------------------------- [ MODAL - CLOSE
	$('.js-modal-close').on('click', function(e) {

		e.preventDefault();

		if( transitionsSupported ) {
			$('.modal').attr('aria-hidden', 'true').one('transitionend', function() {
				$('body').removeClass('has-modal');
				$('.modal__content').empty();
			});
		} else {
			$('.modal').attr('aria-hidden', 'true');
			$('body').removeClass('has-modal');
			$('.modal__content').empty();
		}

	});

	$('.js-toggle-media-selector').on('click', function(e){

		e.preventDefault();

		var selector = $(this).closest('.media-selector');
		selector.toggleClass('js-active');

	});

	$('.js-toggle-language-selector').on('click', function(e){
		e.preventDefault();
		window.toggleLanguage(true);
	});

	// ---------------------------------------------------------------------------------------- [ CAROUSELS
	$('.c-carousel').slick({
		infinite: false,
		responsive: [
			{			
				breakpoint: 1023,
				settings: {
					infinite: true,
					arrows: false,
					dots: true,
					slidesToShow: 2
				}
			},
			{
				breakpoint: 767,
				settings: {
					infinite: true,
					arrows: false,
					dots: true,
					slidesToShow: 1
				}
			}
		]
	});

	// ---------------------------------------------------------------------------------------- [ CUSTOM SELECTS
	// Reference: http://jsfiddle.net/BB3JK/47/

	$('select.select--js-customize').each(function(){
		var $this = $(this), numberOfOptions = $(this).children('option').length;
	  
		$this.addClass('hidden'); 
		$this.wrap('<div class="select--stylized"></div>');
		$this.after('<div class="select__selected-value"></div>');
	
		var $styledSelect = $this.next('div.select__selected-value');
		$styledSelect.text($this.children('option').eq(0).text());
	  
		var $list = $('<ul />', {
			'class': 'select-options'
		}).insertAfter($styledSelect);
	  
		for (var i = 0; i < numberOfOptions; i++) {
			$('<li rel="'+$this.children('option').eq(i).val()+'"><a href="'+$this.children('option').eq(i).val()+'">'+$this.children('option').eq(i).text()+'</a>').appendTo($list);
		}
	  
		var $listItems = $list.children('li');
	  
		$styledSelect.click(function(e) {
			e.stopPropagation();
			$('div.select-styled.active').not(this).each(function(){
				$(this).removeClass('active').next('ul.select-options').hide();
			});
			$(this).toggleClass('active').next('ul.select-options').toggle();
		});
	  
		$listItems.click(function(e) {
			e.stopPropagation();
			$styledSelect.text($(this).text()).removeClass('active');
			$this.val($(this).attr('rel'));
			$list.hide();
		});
	  
		$(document).click(function() {
			$styledSelect.removeClass('active');
			$list.hide();
		});
	
	});

	// ---------------------------------------------------------------------------------------- [ UTM PARAMS
	$(document).ready(function () {
		if ( window.entry_utm_codes ) {
			$('article a[href]').each(function(index) {
				var href = $(this).attr('href');
				var match = href.match(/^(?:https?:)?(?:\/\/)?(?:[^@\n]+@)?([^:\/\n]+)/im);
				if ( match[1] ) {
					var domain = match[1];
					for (var key in window.entry_utm_codes) {
						if ( key === domain ) {
							var keys = window.entry_utm_codes[key];
							var fragments = href.split('?');
							var query = {};
							if ( fragments[1] ) {
								var params = fragments[1].split('&');
								for ( var p = 0; p < params.length; p++ ) {
									var pair = params[p].split('=');
									query[pair[0]] = pair[1];
								}
							}
							for (var k in keys ) {
								if ( ! query[k] ) {
									query[k] = keys[k];
								}
							}
							var queryString = [];
							for (var k in query) {
								queryString.push(k + '=' + query[k])
							}						
							fragments[1] = queryString.join('&');
							$(this).attr('href', fragments.join('?'))
						}
					}
				}
			});
		}
	});

	// ---------------------------------------------------------------------------------------- [ TABLESAW
	Tablesaw.init();

	// var social_is_stuck = false;

	// function stick_social() {

	// 	$('.side-nav').stick_in_parent({
	// 	});

	// 	social_is_stuck = true;

	// }

	// if ( checkBreakPoint('lap') && ! social_is_stuck ) {
	// 	stick_social();
	// }	

})(jQuery, window, document);